import React, { useContext } from 'react';

export const ModuleDisplayModeContext = React.createContext<boolean>(false);

export function useModuleDisplayMode(): boolean {
  return useContext(ModuleDisplayModeContext);
}
